import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for ResetPasswordPage
 *
 */

const ResetPasswordPage = lazyLoad(
  () => import('app/modules/Auth/ResetPassword'),
  (module) => module.default,
);

export default ResetPasswordPage;
